import { AssetEntity } from '@app.raytd.com/store';
import { useMemo } from 'react';

interface Inspection {
  id: number;
  title: string;
  asset: number;
}

export interface GroupedInspections {
  [assetTitle: string]: Inspection[];
}

export function useInspectionData(inspections: Inspection[], assets: AssetEntity[]) {


  const groupedInspections = useMemo(() => {
    if (!inspections) {
      return {};
    }

    const grouped = inspections.reduce((acc, inspection) => {
      // inspection.asset could be a number or an object
      // is inspection.asset is an object then replace it with the id

      const assetId = typeof inspection.asset === 'object' ? (inspection.asset as AssetEntity).id : inspection.asset;

      const matchedAsset = assets.find(asset => asset.id === assetId);
      const assetTitle = matchedAsset?.name || (matchedAsset as any)?.title || 'Unknown';
      if (!acc[assetTitle]) {
        acc[assetTitle] = [];
      }
      acc[assetTitle].push(inspection);
      return acc;
    }, {} as GroupedInspections);

    return grouped;

  }, [inspections, assets]);

  return {groupedInspections};
 

}

